import { Box, Card, Stack, Typography } from '@mui/material';
import ModeCommentOutlinedIcon from '@mui/icons-material/ModeCommentOutlined';
import { CommentAPI, isNil } from '@shared';
import { useState } from 'react';
import * as S from '../../AnomaliesSidebar.styled';
import { Empty, Heading, Time } from '../shared';
import { ConfirmedAnomaliesPropsType } from '../../AnomaliesSidebar.types';
import { AnomalyDetails } from './components/AnomalyDetails';

export type AnomalyUI = {
  start: number;
  uuid: string;
  label: string;
  comments: CommentAPI[];
  anomalyTypeId: number;
  editableComment: boolean;
};

export function ConfirmedAnomalies(props: ConfirmedAnomaliesPropsType) {
  const { anomalies, onSeekChange, anomalyTypes } = props;

  const [isShowAdding, setIsShowAdding] = useState(false);

  const [currentAnomaly, setCurrentAnomaly] = useState<AnomalyUI>({
    start: 0,
    uuid: '',
    label: '',
    comments: [{}] as CommentAPI[],
    anomalyTypeId: 11,
    editableComment: false,
  });

  const handleOpen = (
    start: number,
    uuid: string,
    label: string,
    comments: CommentAPI[],
    anomalyTypeId: number,
    editableComment: boolean
  ) => {
    setIsShowAdding(true);
    setCurrentAnomaly({ start, uuid, label, comments, anomalyTypeId, editableComment });
    onSeekChange(start, true);
  };
  if (isShowAdding) {
    return (
      <AnomalyDetails
        anomalyTypes={anomalyTypes}
        currentAnomaly={currentAnomaly}
        setCurrentAnomaly={setCurrentAnomaly}
        handleClose={() => setIsShowAdding(false)}
      />
    );
  }

  return (
    <>
      <Heading title={'confirmed anomalies'} />
      {anomalies?.length === 0 ? (
        <Empty whichAnomaly={'Confirmed'} />
      ) : (
        <Stack gap={2}>
          {anomalies?.map(({ startOffset, comments, region, uuid, anomalyType }) => (
            <Card
              key={uuid}
              variant='outlined'
              onClick={() =>
                handleOpen(
                  startOffset,
                  uuid,
                  anomalyType.label,
                  comments,
                  anomalyType.id,
                  anomalyType.editableComment
                )
              }
              sx={{ cursor: 'pointer' }}
            >
              <S.CardContentNoPadding>
                <Typography fontWeight={600} fontSize={16}>
                  {anomalyType.label}
                </Typography>
                <Stack direction='row' gap={2} alignItems='center'>
                  <Time time={startOffset} />
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <ModeCommentOutlinedIcon
                      sx={{ transform: 'scale(0.8)' }}
                      opacity={0.6}
                      fontSize='small'
                    />
                    <Typography variant='faded'>{comments?.length || 0}</Typography>
                  </Box>
                  {isNil(region) && <S.Chip label='Manual' />}
                </Stack>
              </S.CardContentNoPadding>
            </Card>
          ))}
        </Stack>
      )}
    </>
  );
}
